import { getInteractionsFromTopicAndState } from 'selectors/block';
import { Action, initialState, State } from 'store/store';

export const updateInteractionsOpen = (
  state: State = initialState,
  { data }: Action
): State => {
  const { blocks, currentTopic, interactionsOpen, nextInteractionMap } = state;
  const currentInteractionId = (data as unknown) as string;

  // interactions in currentTopic
  // get the next interaction.id based on ( current ) data.id
  // add it to the list. . .

  // add the ability to update with an array

  if (Array.isArray(data)) {
    const newInteractionsOpen = data.length
      ? Array.from(new Set([...interactionsOpen, ...data]))
      : [];

    return {
      ...state,
      interactionsOpen: newInteractionsOpen,
    } as any;
  }

  const nextInteractionId = nextInteractionMap[currentInteractionId];

  if (!nextInteractionId) {
    return state;
  }

  if (interactionsOpen.includes(nextInteractionId)) {
    return state;
  } else {
    return {
      ...state,
      interactionsOpen: [...interactionsOpen, nextInteractionId],
    } as any;
  }
};
